import {
  SiPython,
  SiDocker,
  SiReact,
  SiJavascript,
  SiHtml5,
  SiApachespark,
  SiDatabricks,
  SiJupyter,
  SiGithub,
  SiJira,
  SiR,
  SiOpenai,
  SiTensorflow,
  SiGooglecloud,
  SiScikitlearn,
  SiFastapi,
  SiLanggraph,
} from "react-icons/si";
import { FaGitAlt } from "react-icons/fa";
import React from "react";
import StorageIcon from "@mui/icons-material/Storage";
import TerminalIcon from "@mui/icons-material/Terminal";
import CloudIcon from "@mui/icons-material/Cloud";
import BarChartIcon from "@mui/icons-material/BarChart";
import CodeIcon from "@mui/icons-material/Code";
import GridOnIcon from "@mui/icons-material/GridOn";
import FunctionsIcon from "@mui/icons-material/Functions";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import FactoryIcon from "@mui/icons-material/Factory";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";

const ICON_SIZE = 50;

const skillsConfig = {
  mainSkills: [
    { id: "skills-main-python",     className: "skill-icon", icon: <SiPython size={ICON_SIZE} />,                    text: "Python"        },
    { id: "skills-main-sql",        className: "skill-icon", icon: <StorageIcon sx={{ fontSize: ICON_SIZE }} />,      text: "SQL"           },
    { id: "skills-main-spark",      className: "skill-icon", icon: <SiApachespark size={ICON_SIZE} />,               text: "Apache Spark"  },
    { id: "skills-main-azure",      className: "skill-icon", icon: <CloudIcon sx={{ fontSize: ICON_SIZE }} />,        text: "Azure"         },
    { id: "skills-main-databricks", className: "skill-icon", icon: <SiDatabricks size={ICON_SIZE} />,                text: "Databricks"    },
    { id: "skills-main-powerbi",    className: "skill-icon", icon: <BarChartIcon sx={{ fontSize: ICON_SIZE }} />,     text: "Power BI"      },
    { id: "skills-main-git",        className: "skill-icon", icon: <FaGitAlt size={ICON_SIZE} />,                    text: "Git"           },
    { id: "skills-main-docker",     className: "skill-icon", icon: <SiDocker size={ICON_SIZE} />,                    text: "Docker"        },
    { id: "skills-main-fabric",     className: "skill-icon", icon: <FactoryIcon sx={{ fontSize: ICON_SIZE }} />,           text: "Microsoft Fabric" },
    { id: "skills-main-gcp",        className: "skill-icon", icon: <SiGooglecloud size={ICON_SIZE} />,                     text: "Google Cloud"     },
  ],
  languages: [
    { id: "lang-es", name: "Spanish",    nameEs: "Español",    level: "Native",    flag: "https://flagcdn.com/w80/es.png" },
    { id: "lang-en", name: "English",    nameEs: "Inglés",     level: "C2",        flag: "https://flagcdn.com/w80/us.png" },
    { id: "lang-pt", name: "Portuguese", nameEs: "Portugués",  level: "C1",        flag: "https://flagcdn.com/w80/br.png" },
    { id: "lang-it", name: "Italian",    nameEs: "Italiano",   level: "B2",        flag: "https://flagcdn.com/w80/it.png" },
    { id: "lang-fr", name: "French",     nameEs: "Francés",    level: "B2",        flag: "https://flagcdn.com/w80/fr.png" },
    { id: "lang-de", name: "German",     nameEs: "Alemán",     level: "B1",        flag: "https://flagcdn.com/w80/de.png" },
    { id: "lang-zh", name: "Chinese",    nameEs: "Chino",      level: "A2 / HSK3", flag: "https://flagcdn.com/w80/cn.png" },
  ],
  certifications: [
    {
      id: "cert-dp100",
      code: "DP-100",
      name: "Azure Data Scientist Associate",
      issuer: "Microsoft",
      date: "Jan 2026",
      icon: <CloudIcon sx={{ fontSize: 40, color: '#a78bfa' }} />,
    },
    {
      id: "cert-dp700",
      code: "DP-700",
      name: "Fabric Data Engineer Associate",
      issuer: "Microsoft",
      date: "Nov 2025",
      icon: <FactoryIcon sx={{ fontSize: 40, color: '#a78bfa' }} />,
    },
  ],
  complementarySkills: [
    { id: "skills-comp-r",        className: "skill-icon", icon: <SiR size={ICON_SIZE} />,                        text: "R"             },
    { id: "skills-comp-bash",     className: "skill-icon", icon: <TerminalIcon sx={{ fontSize: ICON_SIZE }} />,    text: "Bash"          },
    { id: "skills-comp-js",       className: "skill-icon", icon: <SiJavascript size={ICON_SIZE} />,               text: "JavaScript"    },
    { id: "skills-comp-html",     className: "skill-icon", icon: <SiHtml5 size={ICON_SIZE} />,                    text: "HTML"          },
    { id: "skills-comp-react",    className: "skill-icon", icon: <SiReact size={ICON_SIZE} />,                    text: "React"         },
    { id: "skills-comp-jupyter",  className: "skill-icon", icon: <SiJupyter size={ICON_SIZE} />,                  text: "Jupyter"       },
    { id: "skills-comp-matlab",   className: "skill-icon", icon: <FunctionsIcon sx={{ fontSize: ICON_SIZE }} />,  text: "MATLAB"        },
    { id: "skills-comp-github",   className: "skill-icon", icon: <SiGithub size={ICON_SIZE} />,                   text: "GitHub"        },
    { id: "skills-comp-vscode",   className: "skill-icon", icon: <CodeIcon sx={{ fontSize: ICON_SIZE }} />,       text: "VS Code"       },
    { id: "skills-comp-jira",     className: "skill-icon", icon: <SiJira size={ICON_SIZE} />,                     text: "Jira"          },
    { id: "skills-comp-excel",    className: "skill-icon", icon: <GridOnIcon sx={{ fontSize: ICON_SIZE }} />,     text: "Excel"         },
    { id: "skills-comp-devops",     className: "skill-icon", icon: <AccountTreeIcon sx={{ fontSize: ICON_SIZE }} />,        text: "Azure DevOps"       },
    { id: "skills-comp-adf",        className: "skill-icon", icon: <FactoryIcon sx={{ fontSize: ICON_SIZE }} />,            text: "Azure Data Factory" },
    { id: "skills-comp-openai",     className: "skill-icon", icon: <SiOpenai size={ICON_SIZE} />,                            text: "OpenAI"             },
    { id: "skills-comp-tensorflow", className: "skill-icon", icon: <SiTensorflow size={ICON_SIZE} />,                        text: "TensorFlow"         },
    { id: "skills-comp-azureml",    className: "skill-icon", icon: <AutoAwesomeMotionIcon sx={{ fontSize: ICON_SIZE }} />,   text: "Azure ML"           },
    { id: "skills-comp-sklearn",    className: "skill-icon", icon: <SiScikitlearn size={ICON_SIZE} />,                        text: "scikit-learn"       },
    { id: "skills-comp-fastapi",    className: "skill-icon", icon: <SiFastapi size={ICON_SIZE} />,                            text: "FastAPI"            },
    { id: "skills-comp-chromadb",   className: "skill-icon", icon: <StorageIcon sx={{ fontSize: ICON_SIZE }} />,             text: "ChromaDB"           },
    { id: "skills-comp-langgraph",  className: "skill-icon", icon: <SiLanggraph size={ICON_SIZE} />,                        text: "LangGraph"          },
  ]
};

export default skillsConfig;
